import React, { Component } from "react";
import PropTypes from "prop-types";
import SelectTagButton from "../Buttons/SelectTagButton";
import AddTagButton from "../Buttons/AddTagButton";
import ConfirmModal from "../Modals/ConfirmModal";

class TagsContainer extends Component {
  constructor(props) {
    super(props);
    const { tags } = this.props;
    this.state = {
      tags,
      showConfirmModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tags !== this.state.tags) {
      this.setState({ tags: nextProps.tags });
    }
  }

  handleNewTag = tag => {
    if (this.props.onAddNewTag) {
      this.props.onAddNewTag(tag);
    }
  };

  showDeleteConfirm = tag => {
    this.setState({ showConfirmModal: true });
    this.tagToDelete = tag;
  };

  handleDelete = () => {
    this.props.onDelete(this.tagToDelete);
    this.tagToDelete = null;
    this.setState({ showConfirmModal: false });
  }

  render() {
    const { onClick, onDelete, selectedTags,noAddTagButton,confirmPosition, ...props } = this.props;
    const { showConfirmModal } = this.state;

    const tags = this.state.tags.map(tag => {
      return (
        <SelectTagButton
          key={tag.title}
          isSelected={
            selectedTags
              ? selectedTags.filter(
                  selectedTag => selectedTag.title === tag.title
                ).length > 0
              : false
          }
          onClick={() => onClick(tag)}
          onDelete={() => this.showDeleteConfirm(tag)}
          tag={tag}
          hideCircle={this.props.hideCircles}
          dontChangeColorOnClick
          showDelete
        />
      );
    });

    return (
      <div>
        <div className="tagContainer__tags-list" {...props}>
          {tags}
          {!noAddTagButton && (
            <AddTagButton onAddNewTag={this.handleNewTag} />
          )}
        </div>
        {showConfirmModal && (
          <ConfirmModal
            onDismiss={() => {
              this.setState({ showConfirmModal: false });
            }}
            onApprove={this.handleDelete}
            title="Remove this tag from your team tags?"
            position={confirmPosition || 'fixed' }
          />
        )}
      </div>
    );
  }
}

TagsContainer.propTypes = {
  /** function to call when adding new tag */
  onAddNewTag: PropTypes.func,
  /** function to call when clicking on tag */
  onClick: PropTypes.func,
  /** function to call when clicking on x icon */
  onDelete: PropTypes.func,
  /** list of of tags to show */
  tags: PropTypes.array.isRequired
};

TagsContainer.defaultProps = {
  onAddNewTag: () => {},
  onClick: () => {},
  onDelete: () => {}
};

export default TagsContainer;
